// extracted by mini-css-extract-plugin
export default {"imageContainer":"Vba-z","summaryPar":"Wba-z","ratingCategories":"Xba-z","reviewerInfo":"Yba-z","reviewTypes":"Zba-z","expanded":"_ba-z"};